<template>
  <div class="header">
       <div>
           <div class="header_1">
              <div class="flex" style="align-items: center;justify-content: flex-start;width: 35%;">
                  <a class="logo" href="https://www.gfwlest.com/">
                    <img style="width: 20%;margin-right: 2%;" src="../image/index/blackLogon.png" />
                    <div >
                      <p class="pp" style="font-size: 25px;letter-spacing: 4px;">圭峰网络</p>
                      <p style="letter-spacing: 3px;font-size: 12px;">guifengwangluo</p>
                    </div>
                  </a>
               </div>
               <ul style="margin-top: 23px;">
                  <li  v-for="(item,index) in arr" :key='index'>
                    <p @click="num = index,$router.push(item.key)">{{item.num}}</p>
                    <span :style="num == index?'opacity:1':'opacity:0'" >
                        <span></span>
                    </span>
                  </li>
               </ul>
           </div>
           <div></div>
       </div>
  </div>
</template>

<script>
export default {
  name: 'header',
  data(){
    return{
      num:0,
      arr:['首页','业务范围','合作案例','关于我们','联系我们'],
      arr:[{num:'首页',key:'/'},{num:'业务范围',key:'/business'},{num:'合作案例',key:'/cooperationA'},{num:'关于我们',key:'/about'},{num:'联系我们',key:'/contact'},]
    }
  },
  watch:{
    $route(to,from){
        var bool = false
        this.arr.map((item,index)=>{
          if(item.key == to.path){
              this.num = index
              bool = true
          }
        })
        if(!bool){
          this.num = -1
        }
    }
  },
}
</script>

<style scoped>
.header>div{
  width: 70%;
  margin: 0 auto;

}
.header_1>.flex>.logo{
  display: flex;
  align-items: center;
  color: black;
  text-decoration: none;
}
.header_1{
  display: flex;
  justify-content: space-between;
  height: 120px;
  align-items: center;
}
.header_1 ul{
  display: flex;
  width: 61%;
}
.header_1 ul li{
  width: 20%;
  text-align: center;
}
.header_1 ul li p{
  cursor: pointer;
  font-size: 16px;
}
.header_1 ul li>span{
  display: block;
  width: 45%;
  height: 3px;
  background: black;
  border-radius: 3px;
  margin: 0 auto;
  margin-top: 8px;
  position: relative;
}
.header_1 ul li>span>span{
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 8px solid black;
            position: absolute;
            top: -6px;
            left: 40%;
        }
</style>



// WEBPACK FOOTER //
// src/components/header.vue